/**
 * M2M analytics functions
 */

export function initialise () {
	console.log('[Analytics] M2M initialised');
}

/**
 * Tracking route function
 */
export function trackRoute (route: any, sessionID: string) {
	const obj = {
		path: route.path,
		sessionID,
		timestamp: Date.now(),
		type: 'page-visited'
	};

	try {
		// M2M tracking
		if (webkit && webkit.messageHandlers && webkit.messageHandlers.cordova_iab && webkit.messageHandlers.cordova_iab.postMessage) {
			webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(obj));
		}
	} catch (err) {
		console.warn(err);
	}
}

/**
 * Tracking click function
 */
 export function trackClick (params: any) {
	const obj = Object.assign({}, params, {
		timestamp: Date.now(),
		type: 'click'
	});
	try {
		// M2M tracking
		if (webkit && webkit.messageHandlers && webkit.messageHandlers.cordova_iab && webkit.messageHandlers.cordova_iab.postMessage) {
			webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(obj));
		}
	} catch (err) {
		console.warn(err);
	}
}